import { BudgetCategoryGroup } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateBudgetCategoryGroup {
    constructor(
        public name: BudgetCategoryGroup["name"],
        public category: BudgetCategoryGroup["category"],
        public expense_type_mapping?: BudgetCategoryGroup["expense_type_mapping"],
        public expense_subtype_mapping?: BudgetCategoryGroup["expense_subtype_mapping"],
    ) { }
}
